var module = angular.module('octopusApp.projects');

module.run(function (pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.Vhd", function (octopusRepository, busy) {
        return {
            title: "Deploy a VHD",
            description: "Deploys a VHD to a Hyper-V Host.",
            cssClass: "script",
            priority: 80,
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canChooseRoles: true,
            canHaveChildren: function() { return true; },
            canBeChild: true,
            hasPackages: function(action) { return true; },
            summaryTemplateUrl: "areas/projects/actions/vhd_deploy/Octopus.Vhd_summary.html",
            editTemplateUrl: "areas/projects/actions/vhd_deploy/Octopus.Vhd_edit.html",

            features: {
                permanent: ["Octopus.Features.Vhd"],
                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles" ],
                initial: ["Octopus.Features.SubstituteInFiles"]
            },

            summaryLink: function ($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function (feed) {
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/vhd_deploy/Octopus.Vhd.js
// module id = 684487991542471
// module chunks = 1